import MainService from "@/services/MainService.js";
import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';

Vue.use(VueAxios, axios);

export default {
    name: 'LoginPage',
    data() {
        let ss = new MainService();
        return {
            ss: ss,
            loginRequest: {},
            errorBag: {}
        };
    },
    methods: {
        // Login con email y contrase�a normales
        login() {
            this.ss.login(this.loginRequest)
                .then((result) => {
                    console.log(result);
                    localStorage.setItem('persona', JSON.stringify(result.data.data));
                    localStorage.setItem('token', JSON.stringify(result.data.token));
                    this.$router.push('/');
                    this.$router.go();
                })
                .catch((error) => {
                    this.errorBag = error.response?.data?.errors || {};
                    this.$bvToast.toast(
                        error.response?.data?.msg || 'Problema al iniciar sesi�n',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    );
                });
        },

        // Login con Microsoft / Socialite
        authenticate() {
            window.location.href = 'https://conveniosBackend.net.emi.edu.bo/auth/microsoft/redirect';
        },

                    handleMicrosoftCallback() {
            // Obtener par�metros de la URL (despu�s del hash)
            const hash = window.location.hash;
            const queryString = hash.includes('?') ? hash.split('?')[1] : '';
            const urlParams = new URLSearchParams(queryString);

            const microsoftToken = urlParams.get('microsoft_token');
            const personaEncoded = urlParams.get('persona');
            const error = urlParams.get('error');

            console.log('Par�metros detectados:', { microsoftToken, personaEncoded, error });

            if (error) {
                this.$bvToast.toast(
                    decodeURIComponent(error),
                    {
                        title: 'Error de autenticacion Microsoft',
                        variant: 'danger',
                        autoHideDelay: 5000
                    }
                );
                // Limpia la URL
                this.$router.replace('/Login');
                return;
            }

            if (microsoftToken && personaEncoded) {
                try {
                    // Decodificar datos de persona
                    const persona = JSON.parse(atob(personaEncoded));

                    // Guardar en localStorage
                    localStorage.setItem('persona', JSON.stringify(persona));
                    localStorage.setItem('token', JSON.stringify(microsoftToken));

                    // Mostrar mensaje de �xito
                    this.$bvToast.toast(
                        `�Bienvenido ${persona.Nombres}!`,
                        {
                            title: 'Inicio de sesion exitoso',
                            variant: 'success',
                            autoHideDelay: 3000
                        }
                    );

                    // Redirigir al home
                    setTimeout(() => {
                        this.$router.push('/');
                        this.$router.go();
                    }, 500);

                } catch (e) {
                    console.error('Error al procesar datos de Microsoft:', e);
                    this.$bvToast.toast(
                        'Error al procesar la autenticacion',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    );
                }

                // Limpia la URL
                this.$router.replace('/Login');
            }
        }
    },
    mounted() {
        // Limpia la sesi�n local si hay datos de persona guardados
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (persona) {
            localStorage.clear();
        }

        // Verifica si viene de Microsoft
        this.handleMicrosoftCallback();
    }
}